Object.defineProperty(exports, '__esModule', { value: true });
var styles_1 = require('@material-ui/core/styles');
var React = require('react');
var recompose_1 = require('recompose');
var styles = function(theme) {
  return styles_1.createStyles({
    sdfBackgroundContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: 0,
      margin: 0,
      position: 'relative',
      zIndex: 100,
      minHeight: '100vh',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    },
    sdfLogo: {
      zIndex: 105,
      width: 240,
      marginBottom: 30,
    },
  });
};
var SdfBackground = function(props) {
  var classes = props.classes, children = props.children, hideLogo = props.hideLogo,
    imagesBaseUrl = props.imagesBaseUrl;
  var backgroundImage = {
    backgroundImage: 'url(' + imagesBaseUrl + 'sdf/assets/images/account/sdf-background.jpg)',
  };
  return (React.createElement('div', { className: classes.sdfBackgroundContainer, style: backgroundImage },
    !hideLogo && (React.createElement('img', {
      alt: 'sdf',
      src: imagesBaseUrl + 'sdf/assets/images/common/logo/logo_login_shadow.png',
      className: classes.sdfLogo,
    })),
    children));
};
exports.default = recompose_1.compose(styles_1.withStyles(styles))(SdfBackground);
//# sourceMappingURL=SdfBackground.js.map
